import type { BlockCMS, Product } from '@/types'
import { useState } from 'react'
import ProductCard from '../ProductCard'

interface ModuleProductListFullType {
  data: BlockCMS
  order: number
}
const ModuleProductListFull = ({ data }: ModuleProductListFullType) => {
  const [showItem, setShowItem] = useState(4)
  return (
    <section
      id={data._id}
      className={`${data?.type} ${
        data?.hideBot ? '' : 'pb-3'
      } m-2 rounded-lg bg-white scroll-mt-[150px]`}
    >
      <div
        className='products grid grid-cols-2 gap-2 p-2 mt-2  '
        style={{
          backgroundColor: data?.color,
          backgroundImage: `url(${data?.image})`,
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top left',
        }}
      >
        {data &&
          data?.data.length > 0 &&
          data?.data
            .slice(0, showItem)
            .map((item: Product, idx: number) => (
              <ProductCard layout={2} product={item} key={item._id + idx} />
            ))}
      </div>
      {data && data?.data.length > 4 && (
        <div
          className='w-full pt-2 cursor-pointer text-redPico text-center font-semibold'
          onClick={() => setShowItem(showItem == 4 ? data?.data.length : 4)}
        >
          {showItem === 4 ? 'Xem thêm sản phẩm >>>' : 'Thu gọn'}
        </div>
      )}
    </section>
  )
}

export default ModuleProductListFull
